import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { Analytics } from '@/services/analytics';
import { redactSharePath } from '@/lib/private-share-path';

/**
 * Fires a Firebase Analytics screen_view on every route change, unconditionally
 * (unlike usePageTracking, which only tracks authenticated users for the
 * internal customer-health feature). Mirrors the mobile app's automatic
 * screenView tracking in AppNavigator.
 */
export function useFirebaseScreenTracking() {
  const [location] = useLocation();

  useEffect(() => {
    // A share-link path carries a credential: report it collapsed, never the token.
    Analytics.screenView(redactSharePath(location));
  }, [location]);
}

export default useFirebaseScreenTracking;
